import { deleteAllBingShapes } from '__editor/bingMapsRoofsSelector/components/bingMapsRoofsSelectorDrawingManager/bingMapsRoofsSelectorDrawingManager';

export function resetBingMapsEditor() {
  deleteAllBingShapes();
}
